

export class UserReminderDataInput implements IUserReminderDataInput {
    /** The auto-generated id of the user master */
    userId!: number;

    constructor(data?: IUserReminderDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserReminderDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserReminderDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IUserReminderDataInput {
    /** The auto-generated id of the user master */
    userId: number;
}

